module.exports = "form{\n  padding: 50px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/test-checkout/test-checkout.component.css
// module id = ./src/app/test-checkout/test-checkout.component.css
// module chunks = main